import { ApiResult, request, safeRequest } from '@synergy/api';

import { ProductVariant } from '../models/product-detail-variant';

export class ProductDetailVariantsApi {
    constructor(protected baseUrl: string) {}

    public getVariants(id: number): Promise<ApiResult<ProductVariant[]>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/products/${id}/variants`),
            response => response.data
        );
    }

    public addVariant(productId: number, variant: ProductVariant): Promise<ApiResult<null>> {
        return safeRequest(
            () =>
                request.post(`${this.baseUrl}/products/${productId}/add-variants`, {
                    productIds: [variant.id],
                }),
            response => response.data
        );
    }

    public removeVariant(id: number): Promise<ApiResult<null>> {
        return safeRequest(
            () => request.post(`${this.baseUrl}/products/${id}/remove-variants`, { productIds: [id] }),
            () => null
        );
    }
}
